<template>
  <div>

    <loading v-show="showLoading"></loading>

    <div class="after-status-back"  v-show="!showLoading" >

      <div class="after-status">

        <div class="after-status-desc" v-if="afterDetail.status == 0">
          *您的退货申请已提交，请等待客服审核
        </div>

        <div class="after-status-desc" v-if="afterDetail.status == 1">
          *客服审核中
        </div>

        <div class="after-status-desc" v-if="afterDetail.status == 3">
          *审核通过,请等待退款
        </div>

        <div class="after-status-desc" v-if="afterDetail.status == 4">
          *退款成功，款项将按照实际支付金额退回至原支付账户，预计1～5个工作日到账
        </div>

        <div class="after-status-desc" v-if="afterDetail.status == 5">
          *申请已取消
        </div>

        <div class="after-status-each after-status-height">
          <div class="after-status-each-left">
            申请时间
          </div>
          <div class="after-status-each-right">
            {{afterDetail.date|formatDate}}
          </div>
        </div>

        <div class="after-status-each after-status-height">
          <div class="after-status-each-left">
            售后编号
          </div>
          <div class="after-status-each-right">
            {{afterDetail.code}}
          </div>
        </div>

        <div class="after-status-each after-status-height">
          <div class="after-status-each-left">
            售后类型
          </div>
          <div class="after-status-each-right" v-if="afterDetail.typeId==1">
            退款
          </div>
          <div class="after-status-each-right" v-if="afterDetail.typeId==0">
            退货退款
          </div>
        </div>

        <div class="after-status-each after-status-height">
          <div class="after-status-each-left">
            订单编号
          </div>
          <div class="after-status-each-right">
            {{afterDetail.orderId}}
          </div>
        </div>

        <div class="after-status-each after-status-height">
          <div class="after-status-each-left">
            申请信息
          </div>
        </div>

      </div>

      <div class="after-status-content">
        <div class="after-status-each-goods">
          <div class="after-status-goods" v-if="afterDetail.product">
            <div class="after-status-goods-each">
              <div class="after-status-goods-left">
                <van-image :src="afterDetail.product[0].imgSrc" fit="cover">
                  <template v-slot:error></template>
                </van-image>
              </div>
              <div class="after-status-goods-right">
                <div>
                  <div class="after-status-goods-name">
                    {{afterDetail.product[0].productName}}
                  </div>
                  <div class="after-status-goods-num">
                    x{{afterDetail.product[0].num}}
                  </div>
                </div>
                <div class="after-status-goods-div-bottom">
                  <div class="after-status-goods-price">
                    ¥{{afterDetail.product[0].price}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="after-status-reason">
        <div class="after-status-div head-bold">
          退货原因
        </div>
        <div class="after-status-div">
          {{afterDetail.reasonName}}
        </div>
        <div class="after-status-div">
          {{afterDetail.detail}}
        </div>
      </div>

      <div class="after-status-person" v-show="isReturns == 'Y'">
        <div class="after-person-div">
          联系方式
        </div>
        <div class="after-person-div">
          <div class="after-person-div-left">
            姓名
          </div>
          <div class="after-person-div-right">
            {{afterDetail.partyName}}
          </div>
        </div>
        <div class="after-person-div">
          <div class="after-person-div-left">
            手机
          </div>
          <div class="after-person-div-right">
            {{afterDetail.phone}}
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo } from '@/router/Constant'
  import {afterCancel,login,getAfterSaleDetail} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';
  export default {
    name: "afterStatus",

    data(){
      return{
        showLoading:true,
        token:getStore('externalLoginKey'),
        afterDetail:{},
        show: false,
        allLoaded: false,
        isLoading:false,
        productStoreId:storeName,
        returnId:this.$route.query.returnId,
      }
    },

    mounted(){
      this.showLoading = false
      this.initData()
    },

    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
    },

    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s + ''
        }else{
          return ''
        }

      }
    },

    methods: {

      async initData() {
        this.getAfterDetail()
      },

      //获取售后订单详情
      getAfterDetail: function () {
        let params = {
          externalLoginKey: this.token,
          code: this.returnId,
        }
        getAfterSaleDetail(params)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if (!res._ERROR_MESSAGE_) {
              this.afterDetail = res
            } else {
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            this.showLoading = false
            console.log(err);
          });
      },
    }
  }
</script>

<style>
  .after-status{
    width:100%;
  }
  .after-status-each{
    width:100%;
  }
  .after-status-desc{
    line-height: 1.25rem;
    border-bottom: 1px solid #eee;
    color:#EB84AB;
    font-size: 0.875rem;
    padding: 1rem;
    font-weight: bold;
  }
  .after-status-height{
    height: 3.4375rem;
    line-height: 3.4375rem;
    border-bottom: 1px solid #eee;
  }
  .after-status-each-left{
    display: inline-block;
    vertical-align: top;
    color:#333312;
    font-size: 0.8125rem;
    width:4.5rem;
    margin-left: 1rem;
    text-align: left;
  }
  .after-status-each-right{
    display: inline-block;
    vertical-align: top;
    color:#666666;
    margin-right: 1rem;
    font-size: 0.75rem;
  }
  .after-status-content{
    width:100%;
    margin-bottom: 0.625rem;
  }
  .after-status-each-goods{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .after-status-goods{
    width:100%;
  }
  .after-status-goods-each{
    width:100%;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
  }
  .after-status-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .after-status-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .after-status-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .after-status-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
    width:14rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-status-goods-num{
    float: right;
    vertical-align: top;
    color:#33312E;
    font-size: 0.9375rem;
  }
  .after-status-goods-div-bottom{
    width:100%;
    height: 1.875rem;
    line-height: 1.875rem;
    margin-top: 1rem;
  }
  .after-status-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-status-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }
  .after-status-reason{
    width:100%;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }
  .after-status-div{
    width:21.4375rem;
    margin: 0 auto;
    /*height: 2rem;*/
    line-height: 2rem;
    color:#333;
    font-size: 0.8125rem;
  }
  .head-bold{
    font-weight: bold;
  }
  .after-status-person{
    width:100%;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .after-person-div{
    width:21.4375rem;
    margin: 0 auto;
    height: 2rem;
    line-height: 2rem;
    color:#333;
    font-size: 0.8125rem;
  }
  .after-person-div-left{
    width:3rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-person-div-right{
    display: inline-block;
    vertical-align: top;
  }



</style>



// WEBPACK FOOTER //
// src/components/page/after/afterStatus.vue